import searchTorsoMediaOverlays from "../searchTorsoMediaOverlays";

class LoadMore extends HTMLElement {
    constructor() {
        super()

        this.productsOnPage = document.getElementById("product-grid")
        this.loadMoreButton = this.querySelector(".load-more__btn")
        this.loadMoreButton.addEventListener("click", this.onClick.bind(this))
        this.nextUrl = this.productsOnPage.dataset.nextUrl
    }

    onClick() {
        this.classList.add("loading")
        this.loadMoreProducts()
    }

    async loadMoreProducts() {
        let nextPage = await this.getNextPage()
        window.history.pushState("", "", this.nextUrl)
        const parser = new DOMParser()
        const nextPageDoc = parser.parseFromString(nextPage, "text/html")

        const productgrid = nextPageDoc.getElementById("product-grid")
        const new_products = Array.from(productgrid.getElementsByClassName("grid__item"))
        const new_url = productgrid.dataset.nextUrl
        if (!new_url) {
            this.loadMoreButton.style.display = "none"
        }
        this.nextUrl = new_url
        new_products
        for (let i = 0; i < new_products.length; i++) {
            this.productsOnPage.appendChild(new_products[i])
        }
        this.classList.remove("loading");
        searchTorsoMediaOverlays();
    }

    async getNextPage() {
        try {
            let res = await fetch(this.nextUrl)
            return await res.text()
        } catch (error) {
            console.log(error)
        }
    }
}

customElements.define("load-more", LoadMore)
